<main class="backgroundstyle">
  <div class="container">
      <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <form class="ng-dirty ng-touched ng-valid needs-validation" novalidate [formGroup]="changepasswordform">
              <div class="login-container shadow">
                 
                  <div class="row">
                      <div class="offset-1 col-10 text-center" id="studentvip" *ngIf="parentlogo;else shownormallogo">
                          <img src="{{parentlogo}}" width="100%">
                      </div>
                      <ng-template #shownormallogo>
                        <img class="w-16 md:w-32 lg:w-48 xl:w-64" src="../../assets//img//group_befitzz.png" width="100%">

                                              </ng-template>


                  </div>
                  <br>
                  <div class="row">
                      <div class="text-center sm:text-center" id="subheading">Health | Dental | Wellness</div>
                                            </div> 
                                    <div class="row">
                      <div class="text-center sm:text-center underline">Member Portal</div>
                  </div>


                  <div class="row">
                    <div class="underline" style="margin-top: 25px; text-align: left;margin-left:41px;">{{welcomeMessage}}<b>{{this.firstname ?? this.username}}</b></div>
                </div>
                  <div class="row" style="margin-top: 10px;">
                    <div class="form-group col-1"></div>
                    <div class="form-group col-10">
                      <input type="password" class="form-control checking-field shadow" id="newpassword" placeholder="New Password" formControlName="newpassword"/>
                      <div *ngIf="changepasswordform.get('newpassword').touched && changepasswordform.get('newpassword').invalid" class="help-block text-danger">
                        <div *ngIf="changepasswordform.get('newpassword').errors?.required">{{lang.Please_enter_password}}</div>
                        <div *ngIf="changepasswordform.get('newpassword').errors?.minlength">{{lang.Password_must_be_at_least_8_characters}}</div>
                        <div *ngIf="changepasswordform.get('newpassword').errors?.maxlength">{{lang.Password_must_not_exceed_40_characters}}</div>
                      </div>
                    </div>
                    <div class="form-group col-1"></div>
                  </div>
                  <div class="row" style="margin-top: 10px;">
                    <div class="form-group col-1"></div>
                    <div class="form-group col-10">
                      <input type="password" class="form-control checking-field shadow" id="confirmpassword" placeholder="Confirm Password" formControlName="confirmpassword"/>
                      <div *ngIf="changepasswordform.get('confirmpassword').touched && changepasswordform.get('confirmpassword').invalid" class="help-block text-danger">
                        <div *ngIf="changepasswordform.get('confirmpassword').errors?.required">{{lang.Please_enter_confirm_password}}</div>
                        <div *ngIf="changepasswordform.get('confirmpassword').errors?.minlength">{{lang.Password_must_be_at_least_8_characters}}</div>
                        <div *ngIf="changepasswordform.get('confirmpassword').errors?.maxlength">{{lang.Password_must_not_exceed_40_characters}}</div>
                        <div *ngIf="!changepasswordform.get('confirmpassword').errors?.required && 
                        !changepasswordform.get('confirmpassword').errors?.minlength && 
                        !changepasswordform.get('confirmpassword').errors?.maxlength && 
                        changepasswordform.get('confirmpassword').errors?.confirmedValidator">{{lang.Passwords_did_not_match}}</div>
                      </div>
                    </div>
                    <div class="form-group col-1"></div>
                  </div>
                 
                  <div class="row">
                    <div class="offset-1 col-10 mt-3">
                        <div class="col-12"> <button class="btn btn-light w-100" type="submit" id="submitButton"
                          (click)="SubmitChangePassword()">Submit</button></div>
                    </div>
                </div>
                 
                  
              </div>
          </form>
      </section>
  </div>
  <!-- Activation Modal -->

  <!-- Forgot Password Modal -->

</main>
<footer id="footer" class="footer">
<div class="copyright">
  Version :1.0.39 © {{copyright}} :
  <a class="text-reset" href="https://www.groupbenefitz.ca/" target="-blank">
    The GroupBenefitz Platform Inc.</a>
</div>
</footer>
